<script setup>
  import { ref, computed, onMounted, watchEffect } from 'vue';
  import { useI18n } from 'vue-i18n';
  import BaseModal from './base/BaseModal.vue';

  const { t } = useI18n();

  const showModal = defineModel('showModal', { default: false });
  const emits = defineEmits(['close', 'confirm']);
  const props = defineProps({
    show: {
      type: Boolean,
      default: false
    },
    deviceLabel: {
      type: String,
      default: ''
    },
  });

  const isDeleting = ref(false);

  const deviceLabel = computed(() => props.deviceLabel || t('alertDevices.thisDevice'));

  function closeModal() {
    showModal.value = false;
    emits('close');
  }

  async function handleConfirm() {
    if (isDeleting.value) return;
    isDeleting.value = true;
    try {
      emits('confirm');
    } finally {
      isDeleting.value = false;
    }
  }

  onMounted(() => {
    watchEffect(() => showModal.value = props.show);
  });
</script>

<template>
  <BaseModal
    v-model="showModal"
    :allowOutsideClick="false"
    @close="closeModal"
  >
    <header class="jwx-modal__header">
      <h2 class="jwx-modal__title">{{ t('alertDevices.deleteDeviceTitle') }}</h2>
    </header>
    <div class="jwx-modal__body">
      <div class="jwx-modal__section">
        <i18n-t tag="p" class="jwx-modal__text" keypath="alertDevices.deleteDeviceConfirm">
          <template #device><strong>{{ deviceLabel }}</strong></template>
        </i18n-t>
      </div>
    </div>
    <div class="jwx-modal__footer">
      <div class="jwx-modal__actions">
        <button
          type="button"
          @click.prevent="closeModal"
          class="jwx-button"
        >
          {{ t('common.cancel') }}
        </button>
        <button
          type="button"
          @click.prevent="handleConfirm"
          class="jwx-button"
          data-type="danger"
          :disabled="isDeleting"
        >
          {{ t('common.delete') }}
        </button>
      </div>
    </div>
  </BaseModal>
</template>
